
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Les nouveaux outils de communication du millénaire",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Explorez les nouveaux outils de communication nés du numérique et découvrez comment ils transforment les échanges et la visibilité des entreprises aujourd'hui.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Les nouveaux outils de communication du millénaire",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Avec le numérique, la communication a énormément changé. Cet article vous présente les nouveaux outils de communication du millénaire.",
        },
      ],
    };
  },
};
